import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgModule } from '@angular/core';
import { RxButtonModule } from '@nrwl/rx-button';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxTipModule } from '@nrwl/rx-tip';
import { RxUiModule } from '@nrwl/rx-ui';
import { RxUploadPaidCompositeComponent } from './rx-upload-paid-composite.component';

@NgModule({
  imports: [
    CommonModule,
    RxUiModule,
    RxButtonModule,
    RxIconModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    RxTipModule,
    RxUploadPaidCompositeComponent,
  ],
  exports: [RxUploadPaidCompositeComponent],
})
export class RxUploadPaidCompositeModule {}
